import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { EventTime } from './EventTime';
import { Sponsors } from './Sponsors';
import { Competition } from 'functions/src/types/firestore/Game/Competition';
import { Optional } from 'utility-types';
import { useMobile } from 'src/hooks/useMobile';
import { useReferee } from 'src/contexts/RefereeContext';

export type LeaderboardContainerProps = Optional<
  Pick<Competition<Date>, 'endDate' | 'sponsors'>,
  'endDate'
> & {
  children?: JSX.Element | JSX.Element[];
  RightChildren?: JSX.Element | JSX.Element[];
};

export function LeaderboardContainer({
  endDate,
  sponsors,
  children,
  RightChildren,
}: LeaderboardContainerProps) {
  const { isRefereeView } = useReferee();
  const isMobile = useMobile();
  return (
    <Box mb="48px">
      <Stack
        flexDirection={isMobile ? 'column' : 'row'}
        gap="32px"
        justifyContent="center"
        alignItems={isMobile ? 'center' : undefined}
        sx={{ mt: 4 }}
      >
        {!isRefereeView && (
          <Stack
            gap="16px 0"
            sx={{ width: isMobile ? '100%' : '500px' }}
            alignItems="center"
          >
            {endDate && <EventTime date={endDate} />}
            {children}
            {!!sponsors && (
              <Sponsors
                sponsors={sponsors}
                sx={{
                  width: 'min(586px, 100%)',
                  minHeight: '278px',
                  height: '100%',
                  position: 'relative',
                  mb: 9,
                }}
              />
            )}
          </Stack>
        )}
        <Stack
          gap="16px 0"
          sx={{ width: isMobile || isRefereeView ? '100%' : '50%' }}
        >
          {RightChildren}
        </Stack>
      </Stack>
    </Box>
  );
}
